import axios from "axios";
import { storeConstants } from "../constants";
import { getItemFromLocalStorage } from "../system/storage";

/**
 * Returns the current Payrillium base URL from localStorage.
 * Called at request time so it always reflects the latest stored value.
 */
const getPayrilliumBaseUrl = () =>
  getItemFromLocalStorage(storeConstants.PAYRILLIUM_BASE_URL_STORAGE_KEY);

const handlePayrilliumError = (error) => {
  console.error("Payrillium API error:", error);
  throw new Error(
    error.response?.data?.message || "An error occurred with Payrillium API"
  );
};

const payrilliumPostRequest = (endpoint, data, headers = {}) => {
  return axios
    .post(`${getPayrilliumBaseUrl()}/payrillium/${endpoint}`, data, { headers })
    .then((response) => response?.data, handlePayrilliumError);
};

const payrilliumGetRequest = (endpoint, config = {}) => {
  return axios
    .get(`${getPayrilliumBaseUrl()}/payrillium/${endpoint}`, config)
    .then((response) => response?.data, handlePayrilliumError);
};

const payrilliumCapturePayment = ({
  payment_id,
  transactionId,
  amount,
  href,
}) => {
  return axios.post(
    `https://${process.env.REACT_APP_PAYRILLIUM_URL}/${href}`,
    {
      payment_id,
      transactionId,
      amount,
    },
    {
      "Access-Control-Allow-Origin": true,
    }
  );
};

export {
  payrilliumPostRequest,
  payrilliumGetRequest,
  getPayrilliumBaseUrl,
  payrilliumCapturePayment,
};
